import { ComponentProps } from 'react'
import { cn } from '../../utils/cn'

const controlButtonClassName =
  'relative flex size-[var(--button-size)] items-center justify-center rounded-[8px] border border-solid bg-[length:90%] bg-center bg-no-repeat [--button-size:40px] tall-xxs:rounded-[16px] tall-xxs:[--button-size:50px] md:[--button-size:60px] xl:[--button-size:80px]'

export const GeneratorControlButtonDiv = ({ className = '', ...props }: ComponentProps<'div'>) => (
  <div className={cn(controlButtonClassName, 'border-borderGrey bg-white', className)} {...props} />
)

type GeneratorControlButtonProps = ComponentProps<'button'> & {
  empty?: boolean
  active?: boolean
}

export const GeneratorControlButton = ({
  className = '',
  empty,
  active,
  ...props
}: GeneratorControlButtonProps) => (
  <button
    className={cn(
      controlButtonClassName,
      'p-0',
      {
        'border-borderLightGrey bg-transparent': empty,
        'border-red bg-white': !empty && active,
        'border-borderGrey bg-white': !empty && !active,
      },
      className,
    )}
    {...props}
  />
)

// the panel look shared by the generator controls, without any positioning
export const generatorControlSurfaceClassName =
  'rounded-bl-[17px] rounded-tl-[17px] bg-bgLightGrey px-[12px] py-[10px] shadow-[0_2px_4px_0_rgba(0,0,0,0.2),0_4px_10px_0_rgba(0,0,0,0.2)] sm:p-[15px] md:p-[18px] xl:p-[21px] xxl:rounded-br-[17px] xxl:rounded-tr-[17px]'

export const GeneratorControlWrapper = ({ className = '', ...props }: ComponentProps<'div'>) => (
  <div
    className={cn(
      generatorControlSurfaceClassName,
      'relative z-10 flex h-full justify-between xxl:right-[3vw]',
      className,
    )}
    {...props}
  />
)
